const SI_SYMBOLS = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

/**
 * Returns an abbreviated version of a number.
 * It uses the International System of Units
 * This solution was taken from https://stackoverflow.com/a/65324090
 * updated to allow only a max tier
 * @param value Value to be formatted
 * @param minDigits minimum number of fraction digits
 * @param maxDigits maximum number of fraction digits
 */
export const abbreviateNumber = (
  value: number,
  minDigits?: number,
  maxDigits?: number,
) => {
  if (value === 0 || value === undefined) {
    return 0;
  }

  // determines SI symbol
  const tier = Math.floor(Math.log10(Math.abs(value)) / 3);

  // Make sure not larger than max prefix
  const maxTier = Math.min(tier, SI_SYMBOLS.length - 1);

  // get suffix and determine scale
  const suffix = SI_SYMBOLS[maxTier];
  // Determining the scale
  const scale = 10 ** (maxTier * 3);

  // scale the number
  const scaled = value / scale;

  // format number and add suffix
  return `${scaled.toLocaleString('en-US', {
    minimumFractionDigits: typeof minDigits === 'number' ? minDigits : 0,
    maximumFractionDigits: typeof maxDigits === 'number' ? minDigits : 0,
  })}${suffix}`;
};
